import React from 'react';
import CustomModal from '../CustomModal/CustomModal';
import MyBtn from '../MyBtn/MyBtn';
import s from './SuccessModal.module.css';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  buttonText?: string;
  maxWidth?: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  title = "Success!",
  message,
  buttonText = "Ok",
  maxWidth = "500px"
}) => {
  return (
    <CustomModal 
      isModalOpen={isOpen} 
      setIsModalOpen={onClose}
      maxWidth={maxWidth}
    >
      <div className={s.container}>
        <div className={s.iconContainer}>
          <svg 
            className={s.successIcon} 
            width="48" 
            height="48" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="#22C55E" 
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <path d="m9 12 2 2 4-4"></path>
          </svg>
        </div>
        
        <div className={s.content}>
          <h2 className={s.title}>{title}</h2>
          <p className={s.message}>{message}</p>
        </div>
        
        <div className={s.buttonContainer}>
          <MyBtn 
            title={buttonText}
            onClick={onClose}
          />
        </div>
      </div>
    </CustomModal>
  );
};

export default SuccessModal;
